<template>
  <div id="container-circleProgress" @click="goReport()">
    <canvas
      :id="canvasId"
      :style="{ width: width + 'px', height: height + 'px' }"
    ></canvas>
  </div>
</template>

<script>
import { hMobileHost } from "@/config/env.js";
export default {
  name: "circleProgress",
  props: {
    canvasId: {
      type: String,
      default: "canvas-circleProgress",
    },
    progress: {
      type: Number,
      default: 0,
    },
    perfectValue: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      canvas: "",
      ctx: "",
      circleX: "",
      circleY: "",
      radius: "",
      lineWidth: "",
      process: 0,
      circleLoading: null,
      width: 0,
      height: 0,
      textPadding: 0,
    };
  },
  created() {
    this.init();
    this.$nextTick(() => {
      this.toCanvas();
    });
  },
  watch: {
    progress(val) {
      this.toCanvas();
    },
  },
  methods: {
    /**
     * 初始化后台健康档案的数据比对表
     */
    init() {
      console.log(window.devicePixelRatio);
      this.screenWidth = document.documentElement.clientWidth; // 屏幕宽度
      this.screenHeight = document.documentElement.clientHeight; // 屏幕高度
      window.addEventListener("resize", this.handleResize);
    },
    handleResize() {
      this.screenWidth = document.documentElement.clientWidth;
      this.screenHeight = document.documentElement.clientHeight;
    },
    scaleSize(size) {
      let screenWidth = this.screenWidth;
      if (screenWidth > 540) {
        screenWidth = 540;
      }
      return (screenWidth * size) / 375;
    },
    goReport() {
      if (!this.process) return;
      if (
        this.$store.state.mHealthInfo.appId == "350201" ||
        this.$store.state.mHealthInfo.appId == "345601"
      ) {
        window.location.href =
          hMobileHost +
          "/mobile/home?appId=" +
          this.$store.state.mHealthInfo.appId +
          "&profileId=" +
          this.$store.state.mHealthInfo.profileId;
      }
    },
    //刷新
    loading(dpr) {
      if (this.process >= this.progress) {
        clearInterval(this.circleLoading);
      }
      //清除canvas内容
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.ctx.save();

      this.ctx.translate(this.circleX, this.circleY);

      let font = this.scaleSize(39) * dpr;
      let noDataFont = window.devicePixelRatio == 1 ? 13 : 26;
      this.ctx.font = this.process
        ? `${font}px PingFangSC-Semibold`
        : `${noDataFont}px PingFangSC-normal`;
      this.ctx.textBaseline = "middle";
      this.ctx.textAlign = "center";
      this.ctx.fillStyle = this.process ? "#333" : "#999";
      this.ctx.fillText(
        this.process ? `${this.process}` : "暂无相关健康信息",
        0,
        0
      );

      if (this.progress) {
        this.ctx.beginPath();
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.strokeStyle = "#EBECF2";
        this.ctx.arc(
          0,
          0,
          this.radius - this.lineWidth / 2 - this.textPadding / 2,
          -Math.PI / 2,
          -Math.PI / 2 + (this.perfectValue / 1000) * (Math.PI * 2),
          false
        );
        this.ctx.stroke();

        this.ctx.beginPath();
        //ctx.moveTo(cx, cy + r); // 从圆形底部开始画
        this.ctx.lineWidth = this.lineWidth;
        // 进度条颜色
        this.ctx.strokeStyle = `rgb(${this.$store.state.mHealthInfo.themeColor})`;
        //圆弧两端的样式
        // this.ctx.lineCap = "round";
        //圆弧
        this.ctx.arc(
          0,
          0,
          this.radius - this.lineWidth / 2 - this.textPadding / 2,
          -Math.PI / 2,
          -Math.PI / 2 + (this.process / 1000) * (Math.PI * 2),
          false
        );
        this.ctx.stroke();
        if (this.progress - this.process >= 10) {
          this.process += 9;
        } else {
          this.process += 1.0;
        }
      } else {
        this.ctx.beginPath();
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.strokeStyle = "#EBECF2";
        this.ctx.arc(
          0,
          0,
          this.radius - this.lineWidth / 2 - this.textPadding / 2,
          0,
          Math.PI * 2,
          false
        );
        this.ctx.stroke();
      }

      if (this.perfectValue) {
        this.ctx.strokeStyle = `rgb(${this.$store.state.mHealthInfo.themeColor})`;
        this.ctx.lineWidth = this.scaleSize(1) * dpr;
        this.ctx.beginPath();

        let length1 = this.scaleSize(3) * dpr;
        let angle = (this.perfectValue / 1000) * (Math.PI * 2);
        let x1 =
          Math.cos(angle - Math.PI / 2) *
          (this.radius - this.textPadding / 2 + length1);
        let y1 =
          Math.sin(angle - Math.PI / 2) *
          (this.radius - this.textPadding / 2 + length1);
        let x2 =
          Math.cos(angle - Math.PI / 2) *
          (this.radius - this.textPadding / 2 - this.lineWidth - length1);
        let y2 =
          Math.sin(angle - Math.PI / 2) *
          (this.radius - this.textPadding / 2 - this.lineWidth - length1);

        this.ctx.moveTo(x1, y1);
        this.ctx.lineTo(x2, y2);
        this.ctx.closePath(); //结束路径
        this.ctx.stroke();

        let spacd = this.scaleSize(2) * dpr;

        let font1 = this.scaleSize(12) * dpr;
        this.ctx.font = `${font1}px PingFangSC-Regular`;
        this.ctx.textBaseline = "middle";
        this.ctx.textAlign = "center";
        this.ctx.fillStyle = "#999";
        let textX = Math.cos(angle - Math.PI / 2) * this.radius;
        let textY = Math.sin(angle - Math.PI / 2) * this.radius;
        this.ctx.fillText("理想分值", textX, textY);

        let font2 = this.scaleSize(12) * dpr;
        this.ctx.font = `${font2}px PingFangSC-Medium`;
        this.ctx.textBaseline = "middle";
        this.ctx.textAlign = "center";
        this.ctx.fillStyle = "#333";
        this.ctx.fillText(this.perfectValue, textX, textY + (spacd + font1));
      }

      this.ctx.restore();
    },
    /** 生成环形进度条 **/
    toCanvas() {
      // clearInterval(this.circleLoading);

      let containerProgress = document.getElementById(
        "container-circleProgress"
      );
      let container = containerProgress.getBoundingClientRect();

      this.width = container.width;
      this.height = container.height;

      // console.log('dsafs',this.width,this.height);

      //canvas进度条
      this.canvas = document.getElementById(this.canvasId);
      this.ctx = this.canvas.getContext("2d");

      let dpr = window.devicePixelRatio; // 假设dpr为2
      // console.log(dpr);
      // // 获取css的宽高
      // let { width: cssWidth, height: cssHeight } = this.canvas.getBoundingClientRect();
      // console.log(cssWidth,cssHeight);
      // 根据dpr，扩大canvas画布的像素，使1个canvas像素和1个物理像素相等
      this.canvas.width = dpr * this.width;
      this.canvas.height = dpr * this.height;

      // console.log('canvas',this.canvas.width,this.canvas.height);

      this.circleX = this.canvas.width / 2; //中心x坐标
      this.circleY = this.canvas.height / 2; //中心y坐标

      this.textPadding = this.scaleSize(60) * dpr;

      // console.log(screenWidth,this.scaleSize(40));

      this.radius =
        Math.min(this.canvas.width, this.canvas.height) / 2 -
        this.scaleSize(20) * dpr; // canvas半径

      this.lineWidth = this.scaleSize(15) * dpr; //圆形线条的宽度

      if (!this.progress) {
        this.loading(dpr);
        return;
      }

      this.process = 0; //进度

      this.circleLoading = window.setInterval(() => {
        this.loading(dpr);
      }, 10);
    },
  },
};
</script>

<style scoped>
#container-circleProgress {
  text-align: center;
}
</style>
